export function isPlainObject(value) {
    return (value !== null &&
        typeof value === 'object' &&
        Array.isArray(value) === false);
}
export function isString(value) {
    return typeof value === 'string';
}
export function isHotelId(value) {
    return isString(value) && /^[0-9]+-giata$/.test(value);
}
export function isUrl(value) {
    return isString(value) && /^https:\/\/.+/.test(value);
}
export function isConversion(value) {
    return (isPlainObject(value) &&
        (value.type === 'hotel-listing' || value.type === 'offer-listing') &&
        isUrl(value.trackingUrl));
}
export function isProductConversion(value) {
    return (isPlainObject(value) &&
        typeof value.ts === 'number' &&
        Array.isArray(value.journeys) &&
        isPlainObject(value.conversions) &&
        Object.values(value.conversions).every(isConversion));
}
//# sourceMappingURL=guards.js.map